import { get, orderBy } from 'lodash'

const _ALL = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'

export class ProviderFactory {
  constructor () {
    this[_ALL] = get(require('@/data'), 'players', [])
  }
  get all () {

    return orderBy(this[_ALL], ['index'], ['asc'])
  }

  static create () {
    return new ProviderFactory()
  }
}

export default new ProviderFactory()
